import { CustomerActivityType } from "@redotech/redo-model/marketing/segments/segment-types";
import * as z from "zod/v4";

export const getTokenFieldOptions = {
  name: "getTokenFieldOptions" as const,
  input: z.object({
    dataStructureType: z.enum(CustomerActivityType),
    dataStructureField: z.string(),
    searchString: z.string().optional(),
  }),
  output: z.object({ items: z.array(z.string()) }),
};
